<template>
  <div>
    <v-dialog v-model="dialogIntegration" @keydown.esc="dialogIntegration = false" max-width="600px">
      <v-card>
        <v-card-title>
          <h3 class="headline font-weight-bold">UFI Integration</h3>
        </v-card-title>
        <v-divider></v-divider>
        <div class="pa-4" v-if="integrationItem">
          <v-layout align-center>
            <v-flex xs3 class="text-xs-center">
              <img v-if="integrationItem.image" :src="integrationItem.image" class="item-thumb">
              <div v-else style="width:100%; height: 70px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
            </v-flex>
            <v-flex xs9 class="text-xs-left">
              <div class="font-weight-bold black--text"><a :href="def.marketplaceDomain + integrationItem.url" target="_blank">{{ integrationItem.name }}</a></div>
              <div v-for="(param, paramIndex) in integrationItem.itemParams" :key="'issue' + integrationItem.sku + integrationItem.paramHash + '-' + paramIndex">
                <span class="font-weight-medium">{{ param.name }}: </span>
                <span v-if="param.value">{{ param.value }}</span>
                <div v-if="param.selections">
                  <div v-for="(selection, selectionIndex) in param.selections" :key="'issue' + integrationItem.sku + integrationItem.paramHash + '-' + paramIndex + '-' + selectionIndex">
                    {{ selection.name }} <span v-if="selection.priceInBase > 0">{{ currencySign + formatPrice(selection.priceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</span><span v-else-if="selection.price > 0">{{ currencySign + formatPrice(selection.price, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</span>
                  </div>
                </div>
              </div>
              <div v-for="option in integrationItem.options" :key="'issue' + option.productOptionId">
                <span class="font-weight-medium">{{ option.optionName }}:</span> <span>{{ option.valueName }}</span>
              </div>
              <div v-if="integrationItem.itemPreparedBy && integrationItem.itemPreparedBy.length > 0">
                <div class="caption black--text mt-3"><strong>Prepared by:</strong>{{ integrationItem.itemPreparedBy }}</div>
                <div class="caption black--text"><strong>Seller has sent:</strong> {{ integrationItem.incomingQty }} of {{ integrationItem.qty }}</div>
              </div>
            </v-flex>
          </v-layout>
        </div>
        <v-divider v-if="integrationItem"></v-divider>
        <div v-if="ufiAccountInfo && ufiAccountInfo.name">
          <v-container fluid grid-list-lg class="pa-4">
            <v-layout row wrap>
              <v-flex xs2 class="text-xs-right font-weight-bold">
                Name
              </v-flex>
              <v-flex xs10 class="text-xs-left">
                {{ ufiAccountInfo.name }}
              </v-flex>
              <v-flex xs2 class="text-xs-right font-weight-bold">
                Email
              </v-flex>
              <v-flex xs10 class="text-xs-left">
                {{ ufiAccountInfo.email }}
              </v-flex>
              <v-flex xs2 class="text-xs-right font-weight-bold">
                Balance
              </v-flex>
              <v-flex xs10 class="text-xs-left">
                {{ ufiAccountInfo.balance }} credits
                <v-btn
                  outline
                  small
                  @click="getUfiAccountInfo"
                  :disabled="disableRefreshButton"
                >
                  Refresh
                </v-btn>
                <v-btn
                  outline
                  small
                  @click="showTransferDialog"
                  :disabled="disableRefreshButton"
                >
                  Transfer
                </v-btn>
              </v-flex>
              <v-flex xs2 class="text-xs-right font-weight-bold">
                Logs
              </v-flex>
              <v-flex xs10 class="text-xs-left">
                <div style="overflow-y: scroll; max-height: 300px;">
                  <div v-for="(log, logIndex) in ufiAccountInfo.logs" :key="logIndex">
                    <div class="font-weight-bold caption">{{ log.dateTime }}</div>
                    <div>{{ log.description }}</div>
                    <v-divider class="mt-3 mb-3"></v-divider>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
        <div class="pa-4" v-else>
          <v-btn
            outline
            block
            @click="getUfiAccountInfo"
            :disabled="disableRefreshButton"
          >
            Get UFI Account Info
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogTransfer" @keydown.esc="dialogTransfer = false" max-width="400px">
      <v-card class="pa-3">
        <v-card-title>
          <h2>Transfer Credit</h2>
        </v-card-title>
        <v-card-text>
          <v-form ref="frmTransfer" v-model="frmTransferValid">
            <v-text-field
              v-model="txtTransferEmail"
              label="Target Email"
            ></v-text-field>
            <v-text-field
              v-model="txtTransferAccountId"
              label="Target Account ID"
            ></v-text-field>
            <v-text-field
              v-model="txtTransferAmount"
              :rules="[v => /^[-|+]?\d*$/.test(v) || 'Amount must be integer', v => v > 0 || 'Amount must be > 0']"
              label="Amount"
              type="number"
              required
            ></v-text-field>
            <v-btn
              block
              large
              color="primary"
              :disabled="!frmTransferValid"
              @click="transfer"
            >
              Transfer Credit
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="220"
    >
      <loading></loading>
    </v-dialog>
  </div>
</template>

<style scoped>
  .item-name {
    padding: 5px !important;
  }

  .item-thumb {
    width: 60px;
    height: auto;
  }
</style>

<script>
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'

export default {
  components: {
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      loading: false,
      disableRefreshButton: false,
      dialogIntegration: false,
      integrationItem: {},
      ufiAccountInfo: {},
      dialogTransfer: false,
      frmTransferValid: false,
      txtTransferEmail: '',
      txtTransferAccountId: '',
      txtTransferAmount: 0
    }
  },
  methods: {
    showIntegrationDialog: function (item) {
      this.disableRefreshButton = false
      this.integrationItem = item
      this.ufiAccountInfo = {}
      this.txtTransferEmail = ''
      this.txtTransferAccountId = ''
      this.txtTransferAmount = 0
      this.dialogIntegration = true
    },
    getUfiAccountInfo: function () {
      var _this = this
      _this.loading = true
      _this.disableRefreshButton = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/integration/ufi/me')
        .then(resp => {
          _this.loading = false
          _this.disableRefreshButton = false
          if (resp.data.status === 'success') {
            this.ufiAccountInfo = resp.data.data
          } else {
            window.alert('unable to connect: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(_this)
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
            _this.disableRefreshButton = false
          }
        })
    },
    showTransferDialog: function () {
      this.frmTransferValid = false
      this.txtTransferEmail = ''
      this.txtTransferAccountId = ''
      this.txtTransferAmount = 0
      this.dialogTransfer = true
    },
    transfer: function () {
      var _this = this
      if (_this.$refs.frmTransfer.validate()) {
        _this.loading = true
        let postData = {
          targetEmail: _this.txtTransferEmail,
          targetAccountId: _this.txtTransferAccountId,
          credit: _this.txtTransferAmount
        }
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/integration/ufi/transfer', postData)
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              window.alert('Transfer Success')
              this.getUfiAccountInfo()
            } else {
              window.alert('Fail: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(this)
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              }
              _this.loading = false
            }
          })
      }
    }
  }
}

</script>
